import styled from 'styled-components'

interface Props {
  children: any,
  autoWidth?: boolean
}

const FlexGap = ({ children, autoWidth }: Props) => <S_FlexGap autoWidth={autoWidth}>{ children }</S_FlexGap>

export default FlexGap

const S_FlexGap = styled.div`
  width: ${props => props.autoWidth ? 'auto' : '100%'};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
`
